import React from 'react';
import _get from 'lodash/get';
import { CardActionArea, Typography, makeStyles } from '@material-ui/core';
import Badge from 'components/Badge';
import _classNames from 'classnames';
import { getDurationLabel } from 'utils/stringUtils';
import { sharedStyles } from 'containers/Series/components/seriesSharedStyles';
import { CourseSeriesStatusIcon } from './CourseStatusIcon';

const useStyles = makeStyles(theme => ({
  ...sharedStyles(theme),
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,

    '& svg': {
      flexShrink: 0,
    },
  },
  resourceTitle: {
    ...theme.typography.pSmallBold,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: 8,
    gap: 5,
    padding: '10px 20px',
    border: '1px solid #E0E0E0',
    marginLeft: 30,

    '&.active': {
      background:
        'linear-gradient(81deg, rgba(212, 246, 255, 0.50) 0%, rgba(211, 236, 255, 0.50) 100%)',
    },

    '&.completed': {
      marginLeft: 0,
    },

    '&.Mui-disabled': {
      backgroundColor: '#F8F9F9',
      border: '1px solid transparent',
      marginLeft: 0,
    },
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  divider: {
    borderRight: '1px solid #E0E0E0',
    height: 12,
  },
  lengthBadge: {
    ...theme.typography.pxSmall,
  },
  seriesCount: {
    ...theme.typography.pxSmall,
  },
}));

export const CourseDefaultCard = ({
  item,
  index,
  type,
  active,
  completed,
  disabled,
  onClick,
  resourceItemPageSiteCopy,
  minutes,
  seriesCount,
}) => {
  const classes = useStyles();
  const { fields } = item;
  const title = _get(fields, 'name') || _get(fields, 'title', '');

  return (
    <div className={classes.root}>
      <CourseSeriesStatusIcon completed={completed} disabled={disabled} />
      <CardActionArea
        disabled={disabled}
        className={_classNames(classes.card, {
          completed,
          active,
        })}
        onClick={() => onClick(index, completed)}
      >
        <Typography className={classes.resourceTitle}>{title}</Typography>
        <div className={classes.details}>
          {seriesCount ? (
            <Typography className={classes.seriesCount} color="primary">
              {seriesCount}
            </Typography>
          ) : (
            <Badge customClasses={classes} type={type} />
          )}
          {!!minutes && (
            <>
              <div className={classes.divider} />
              <Typography color="textPrimary" className={classes.lengthBadge}>
                {minutes} {getDurationLabel(resourceItemPageSiteCopy, minutes)}
              </Typography>
            </>
          )}
        </div>
      </CardActionArea>
    </div>
  );
};
